import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { FieldValidationMsgPipe } from '@shared/pipes';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
  selector: 'moxi-notification-emails-form-group',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FieldValidationMsgPipe,
    TranslatePipe,
    // Ant Design
    NzFormModule,
    NzInputModule
  ],
  templateUrl: './notification-emails-form-group.component.html',
  styleUrl: './notification-emails-form-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationEmailsFormGroupComponent implements OnInit {
  formGroup = input.required<FormGroup>();
  emailInfo = input.required<string[]>();
  showTitle = input(true);

  ngOnInit(): void {
    this.formGroup()?.setControl(
      'notificationEmails',
      new FormControl(this.emailInfo()?.toString())
    );
  }
}
